<template>
    <div>
        <v-card flat color="#0e97d6" rounded="0" class="px-0">
            <v-container>
                <div class="pt-5" :class="display.mdAndUp.value ? '' : 'px-5'">
                    <v-row class="align-center">
                        <v-col
                            cols="12"
                            md="6"
                            :class="
                                display.mdAndUp.value
                                    ? 'text-left'
                                    : 'text-center pt-10'
                            "
                        >
                            <div class="font-weight-600 font-size-24">
                                Beli Paket Belajar
                            </div>

                            <div class="mt-1 font-size-16">
                                Aktivasi sekarang untuk mulai petualangan
                                belajar terbaik di Skolla!
                            </div>
                        </v-col>

                        <v-col cols="12" md="6" style="min-height: 295px">
                            <div
                                class="d-flex"
                                :class="
                                    display.mdAndUp.value
                                        ? 'justify-end'
                                        : 'justify-center mt-5'
                                "
                                style="margin-bottom: -17px"
                            >
                                <img
                                    width="360"
                                    :src="
                                        require('@/assets/images/home-banner.png')
                                    "
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </v-card>

        <v-container>
            <div class="mt-10" :class="display.mdAndUp.value ? '' : 'px-3'">
                <!-- <div class="d-flex gap-10 pb-4 custom-scroll-h">
                    <v-btn
                        v-for="(tab, i) in tabs"
                        :key="i"
                        rounded="pill"
                        :color="
                            selected_tabs === tab.id ? '#0e97d6' : '#f0f3f9'
                        "
                        :class="
                            selected_tabs === tab.id
                                ? 'text-white'
                                : 'text-blacknew'
                        "
                        depressed
                        variant="flat"
                        @click="setSelectedTab(tab)"
                    >
                        {{ tab.text }}
                    </v-btn>
                </div> -->

                <div class="mt-3">
                    <v-row class="align-center gap-3" no-gutters>
                        <v-col cols="12" md="7" lg="9" class="pr-3 pb-2">
                            <v-text-field
                                v-model="search"
                                variant="flat"
                                placeholder="Cari paket sesuai kebutuhanmu"
                                density="compact"
                                hide-details
                                class="bg-white custom-input"
                                color="primary"
                                @keyup.enter="getPackageData()"
                            />
                        </v-col>

                        <v-col cols="12" md="5" lg="3" class="pb-2">
                            <v-btn
                                variant="flat"
                                color="white"
                                size="large"
                                class="rounded-5 px-3"
                                style="border: 1.5px solid #d7dfe9"
                                @click="dialogFilterPackage = true"
                            >
                                <span class="text-blacknew font-weight-400">
                                    Filter
                                </span>

                                <img
                                    :src="require('@/assets/icons/filter.svg')"
                                    class="ml-2"
                                />
                            </v-btn>

                            <v-menu>
                                <!-- Tombol Activator -->
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        v-bind="props"
                                        variant="flat"
                                        color="white"
                                        size="large"
                                        class="rounded-5 px-3 ml-2"
                                        style="border: 1.5px solid #d7dfe9"
                                    >
                                        <span
                                            class="text-blacknew font-weight-400"
                                        >
                                            Urutkan
                                        </span>
                                        <img
                                            :src="
                                                require('@/assets/icons/chevron-down.svg')
                                            "
                                            class="ml-2"
                                        />
                                    </v-btn>
                                </template>

                                <!-- Isi Dropdown -->
                                <v-list class="rounded-lg">
                                    <v-list-item
                                        v-for="(option, i) in sortOptions"
                                        :key="i"
                                        @click="selectedSortOptions = option"
                                        :class="
                                            selected === option.id
                                                ? 'active-option'
                                                : ''
                                        "
                                    >
                                        <v-list-item-title>
                                            {{ option.text }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                    </v-row>
                </div>

                <div v-if="loading" class="text-center py-10">
                    <v-progress-circular
                        color="#0e97d6"
                        indeterminate
                        size="50"
                        width="6"
                    ></v-progress-circular>
                </div>

                <div v-if="!loading && packages.length" class="mt-5">
                    <v-row>
                        <v-col
                            v-for="(item, i) in packages"
                            :key="i"
                            cols="12"
                            md="6"
                            lg="4"
                        >
                            <card-package
                                :data="item"
                                @detail="openDetailPackage(item)"
                            />
                        </v-col>
                    </v-row>
                </div>

                <div
                    v-if="!loading && !packages.length"
                    class="mt-5 pdy-50 text-center"
                >
                    Data Paket tidak ditemukan
                </div>
            </div>
        </v-container>

        <dialog-filter-package
            :dialog="dialogFilterPackage"
            @close="dialogFilterPackage = false"
            @filter="setFilterPackage($event)"
        />

        <dialog-promo
            :dialog="dialogPromo"
            :data="banner_promo"
            @close="closeDialogPromo()"
        />
    </div>
</template>

<script>
import CardPackage from './components/CardPackage.vue';
import DialogFilterPackage from './components/DialogFilterPackage.vue';
import DialogPromo from './components/DialogPromo.vue';
import Cookies from 'js-cookie';

export default {
    inject: ['display'],

    components: {
        CardPackage,
        DialogFilterPackage,
        DialogPromo,
    },

    data() {
        return {
            loading: false,
            selected: null,
            dialogFilterPackage: false,
            dialogPromo: false,
            search: null,
            packages: [],
            tabs: [
                // {
                //     id: 'semua_paket',
                //     text: 'Semua Paket',
                // },
                {
                    id: 'paket_belajar',
                    text: 'Paket Belajar',
                },
                // {
                //     id: 'paket_addon',
                //     text: 'Paket Add On',
                // },
                {
                    id: 'bandingkan_paket',
                    text: 'Bandingkan Paket',
                },
            ],
            selectedSortOptions: null,
            sortOptions: [
                {
                    id: 'price',
                    text: 'Harga Tertinggi',
                    sort_type: 'desc',
                },
                {
                    id: 'price',
                    text: 'Harga Terendah',
                    sort_type: 'asc',
                },
                {
                    id: 'discount',
                    text: 'Diskon Terbesar',
                    sort_type: 'desc',
                },
                {
                    id: 'discount',
                    text: 'Diskon Terkecil',
                    sort_type: 'asc',
                },
            ],
            selected_tabs: 'semua_paket',
            filter: {},
            banner_promo: [],
            url_referrer_source: null,
            url_referrer_referral_code: null,
            doc_referrer: null,
            generated_id: null,
        };
    },

    watch: {
        selectedSortOptions() {
            this.getPackageData();
        },
    },

    mounted() {
        this.getPackageData();
        this.getPromo();
        this.getUrlReferrer();
    },

    methods: {
        async getPackageData() {
            this.loading = true;
            try {
                this.packages = await this.$axios.get(
                    'payment/package/list/wp',
                    {
                        params: {
                            search: this.search,
                            feature: this.filter.feature || '',
                            level: this.filter.level || '',
                            grade: this.filter.grade || '',
                            sort_by: this.selectedSortOptions?.id || 'sequence',
                            sort_direction:
                                this.selectedSortOptions?.sort_type || 'asc',
                        },
                    }
                );
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        setSelectedTab(val) {
            this.selected_tabs = val.id;
        },

        setFilterPackage(val) {
            this.dialogFilterPackage = false;

            if (val.grade === 13) {
                val.grade = 12;
            }

            this.filter = val;
            this.getPackageData();
        },

        openDetailPackage(item) {
            this.$router.push(`/detail-paket-belajar?id=${item.id}`);
        },

        async getPromo() {
            const url = 'general-service/pop-ads/list-app';

            try {
                const response = await this.$axios.get(url);
                this.banner_promo = response.filter(
                    (e) => e.is_active === true && e.is_webpurchase === true
                );

                const banner_promo_cookies = this.getCookies('banner_promo');

                if (!banner_promo_cookies && this.banner_promo.length) {
                    this.dialogPromo = true;
                    this.createCookies('banner_promo', true, 1);
                }
            } catch (error) {
                console.log(error);
            }
        },

        closeDialogPromo() {
            this.dialogPromo = false;
        },

        createCookies(name, value, days) {
            Cookies.set(name, value, { expires: days });
        },

        getCookies(name) {
            return Cookies.get(name);
        },

        getUrlReferrer() {
            const url_referrer_source = this.$route.query.source;

            this.url_referrer_desc = `url_referrer:${url_referrer_source}`;
            this.url_referrer_referral_code = this.$route.query.referral_code;
            this.doc_referrer = document.referrer;
            this.generated_id = crypto.randomUUID();

            if (
                this.doc_referrer &&
                url_referrer_source &&
                this.url_referrer_referral_code
            ) {
                this.createCookies(
                    'url_referrer_referral_code',
                    this.url_referrer_referral_code,
                    1
                );

                this.createCookies(
                    'url_referrer_desc',
                    this.url_referrer_desc,
                    1
                );

                this.createCookies('url_referrer_source', this.doc_referrer, 1);

                this.createCookies(
                    'url_referrer_generated_id',
                    this.generated_id,
                    1
                );

                this.addUtmReferrer();
            }
        },

        async addUtmReferrer() {
            const generated_id = this.generated_id;
            const url_referrer_source = this.doc_referrer || null;
            const url_referrer_desc = this.url_referrer_desc;
            const url_refferral_code = this.url_referrer_referral_code;

            const params = {
                user_id: null,
                user_email: null,
                source: url_referrer_source,
                description: url_referrer_desc,
                refferral_code: url_refferral_code,
                generated_id: generated_id,
            };

            try {
                await this.$axios.post('/log-service/utm-refferrer', params);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
